import { AttacherNodesByModelId } from "@animech/supermodel";
import { createModelNodesMap, createNodeModelMap } from "./utility";
import {
	AttacherGroup,
	AttacherGroupDefinition,
	createAttacherGroup,
} from "./attacher-group";

// TODO: Groups need to be defined per application.
const groupDefinitions = [] satisfies AttacherGroupDefinition[];

export function createAttacherGroups(
	attacherNodesByModel: AttacherNodesByModelId,
): AttacherGroup[] {
	const modelNodesMap = createModelNodesMap(attacherNodesByModel);
	const nodeModelMap = createNodeModelMap(modelNodesMap);
	return groupDefinitions.map((definition) =>
		createAttacherGroup(definition, modelNodesMap, nodeModelMap),
	);
}
